export const USDDollarFormatter = (value: number, sign: 'USD') => {
  const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: sign,
  })
  return USDollar.format(value)
}
